<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col cols="3" class="py-0 my-0">
                    <client-selector :addAllOption="false" class="py-0 my-0 " ref="clientSelector" @getClients="v => items.clients = v" :is_national="2"></client-selector>  
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="5" align="end" class="py-0">
                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" @click="show_export_options = true" v-if="show_export_options == false">
                        {{ $t('stock_report.export') }}
                    </v-btn>

                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" v-if="show_export_options" @click="exportDataPdf">
                        PDF
                    </v-btn>
                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" v-if="show_export_options" @click="exportDataExcel">
                        Excel
                    </v-btn>

                    <v-btn class="right tools-view-height mr-3" outlined color="secondary" v-if="show_export_options" @click="show_export_options = false;">
                        <v-icon small class="px-0">
                            keyboard_arrow_left
                        </v-icon>
                    </v-btn>
                    <v-btn class="right white_highlight--text tools-view-height" color="secondary" @click="generate">
                        {{ $t('history_product.generate') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :props="{headers:headers, items: props.items, search:props.search}" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import FileSaver from 'file-saver';

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('history_product.sku'), align: "center", value: 'sku', class: 'text-uppercase' },
                { text: this.$t('history_product.income_movements'), align: "center", value: 'income_total', class: 'text-uppercase' },
                { text: this.$t('history_product.outcome_movements'), align: "center", value: 'outcome_total', class: 'text-uppercase' },
                { text: this.$t('history_product.fulfillment'), align: "center", value: 'fulfillment_total', class: 'text-uppercase' },
                { text: this.$t('history_product.ffx'), align: "center", value: 'ffx_total', class: 'text-uppercase' },
                { text: this.$t('history_product.returned'), align: "center", value: 'returned_total', class: 'text-uppercase' },
                { text: this.$t('history_product.stock'), align: "center", value: 'stock', class: 'text-uppercase' },
                { text: this.$t('history_product.reserved'), align: "center", value: 'reserved', class: 'text-uppercase' },
                { text: this.$t('history_product.damaged'), align: "center", value: 'damaged', class: 'text-uppercase' },
            ];
        },
        client: function(){
            return this.$store.state.clientId
        },
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            props: {
                search: '',
                items: [],
            },
            report:{
                initial_date: '',
                final_date: ''
            },
            show_export_options: false
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.history_product";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        index(){
            this.props.items = [];
        },
        generate(){
            this.props.items = [];
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            if(this.$store.state.clientId != ""){
                this.$http.get(this.$store.state.chronosApi + 'reports/productHistory?clientId=' + this.$store.state.clientId, {headers: {Authorization: lsToken}})
                .then((response) => {
                    var count = 0;
                    response.data.data.forEach(x => {
                        x.id = count++;
                        this.props.items.push(x);
                    })
                })
                .catch((response) => {
                    this.$store.state.loaderProps.visible = false;
                    if(response.status !== 200){
                        this.snackbar = {
                            visible: true,
                            color: 'red',
                            text: this.$t('pendings.responses.error')
                        }
                    }
                }).finally(() => {
                    this.$store.state.loaderProps.visible = false;
                });
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('yego_reports.export_error')
                };
            }
        },
        exportDataExcel(){
            if(this.$store.state.clientId != ""){
                this.$store.state.loaderProps.visible = true
                const lsToken = localStorage.getItem("access_token")
                this.$http.get(this.$store.state.chronosApi + '/reports/productHistoryExport?clientId='+ this.$store.state.clientId, {headers: {Authorization: lsToken}, responseType:'blob' })
                .then(response => {
                    this.$store.state.loaderProps.visible = false; 
                    FileSaver.saveAs(response.data, 'Historial_Productos.xlsx');
                })
                .catch(() => {
                    this.$store.state.loaderProps.visible = false;
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('yego_reports.export_error')
                    };
                })
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('yego_reports.export_error')
                };
            }
        },
        exportDataPdf(){
            if(this.$store.state.clientId != ""){
                this.$store.state.loaderProps.visible = true
                const lsToken = localStorage.getItem("access_token")
                this.$http.get(this.$store.state.chronosApi + 'reports/productHistoryPDF?clientId='+ this.$store.state.clientId, {headers: {Authorization: lsToken}, responseType:'blob' })
                .then(response => {
                    this.$store.state.loaderProps.visible = false; 
                    FileSaver.saveAs(response.data, 'Historial_Productos.pdf');
                })
                .catch(() => {
                    this.$store.state.loaderProps.visible = false;
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: this.$t('yego_reports.export_error')
                    };
                })
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('yego_reports.export_error')
                };
            }
        }
    }
}
</script>
<style>
</style>